export default __webpack_public_path__ + "static/media/116.8037960a.gif";